export const defaultColDef = {
  sortable: true,
  editable: false,
  flex: 1,
  filter: true,
  floatingFilter: true,
  suppressMenu: true,
  floatingFilterComponentParams: { suppressFilterButton: true },
}
